import {kapitelDateString, kapitelDateTimeString, kapitelTimeString} from "@/graphql/kapitelTypes";
import {DurationObjectUnits, DurationUnits, DateTime as LuxonDateTime, Interval as LuxonInterval} from "luxon";
import date from "./date";
import time from "./time";
import datetime, {kapitelDateTimeFormatTime} from "@/helper/datetime/datetime";
import {pluralize} from "@/helper/amountFormatter";

const formatTimeRange = (
    begin: kapitelDateTimeString,
    until: kapitelDateTimeString,
    format = kapitelDateTimeFormatTime,
    divider : ' bis ' | '&ndash;' | string = ' bis '
) => datetime.formatTime(begin, format) + divider + datetime.formatTime(until, format)

const formatTimeRangeObject = (
    object: {begin:kapitelDateTimeString, until:kapitelDateTimeString},
    format = kapitelDateTimeFormatTime,
    divider : ' bis ' | '&ndash;' | string = ' bis '
) => formatTimeRange(object.begin, object.until, format, divider);

export default {
    formatTimeRange,
    formatTimeRangeObject
}
